import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { BrandSettingsRouterLinkDirective } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  type IAutomationConfiguration,
  type ITreatmentConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import { resolveDocRefs, type WithRef } from '@principle-theorem/shared';
import { type Observable, ReplaySubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-automation-treatments',
  templateUrl: './automation-treatments.component.html',
  styleUrls: ['./automation-treatments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    MatListModule,
    MatDialogModule,
    BrandSettingsRouterLinkDirective,
  ],
})
export class AutomationTreatmentsComponent {
  private _config$ = new ReplaySubject<WithRef<IAutomationConfiguration>>(1);
  treatments$: Observable<WithRef<ITreatmentConfiguration>[]>;

  @Input()
  set config(config: WithRef<IAutomationConfiguration>) {
    if (config) {
      this._config$.next(config);
    }
  }

  constructor() {
    this.treatments$ = this._config$.pipe(
      switchMap((config) => resolveDocRefs(config.treatmentRefs))
    );
  }
}
